/* @flow */
import cx from 'classnames';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';

import './styles/JoinAvatarPanel.scss';

class JoinGroupAvatarPanel extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    group: PropTypes.instanceOf(Group).isRequired,
    className: PropTypes.string,
  };

  render() {
    const { group } = this.props;
    const org = group.getOrganization();
    return (
      <div className={cx('JoinAvatarPanel', this.props.className)}>
        <div className="JoinAvatarPanel-Image">
          <GroupAvatar group={this.props.group} />
        </div>

        <div className="JoinAvatarPanel-Header">
          <h4>
            <p>{this.props.group.getPossessiveSignature()}</p>
            <strong>
              <GroupName group={group} />
            </strong>
          </h4>
        </div>

        <div className="JoinAvatarPanel-Footer">
          <div>{org && org.getName()}</div>
          <div>@{this.props.group.getCodeOrError()}</div>
        </div>
      </div>
    );
  }
}

export default JoinGroupAvatarPanel;
